import Logo from "../Logo/Logo";
import './common.scss';

export default function Loading(props: {}) {

    return (
        <div className="loading">
            <div className="loading_spinner">
                <img src={'/logo192.png'} className="Logo" alt="logo" />
            </div>
        </div>
    )
}


